import React from 'react';
import './FooterPage.css';
import FooterLogo from "./footerlogo.png"

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="alpha_footer_pg_root">
      <div className="alpha_footer_pg_overlay">

        {/* Top decorative divider */}
        <div className="alpha_footer_pg_top_divider">
          <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="rgba(255,255,255,0.18)" />
          </svg>
        </div>

        <div className="alpha_footer_pg_container">
          <div className="alpha_footer_pg_grid">

            {/* Brand Section */}
            <div className="alpha_footer_pg_brand_col">
              <div className="alpha_footer_pg_logo_wrap">
                <img
                  src={FooterLogo}
                  className="alpha_footer_pg_logo"
                  alt="Alphaingen Logo"
                />
              </div>
              <p className="alpha_footer_pg_brand_desc">
                Alphaingen is a leading medical coding and billing training institution and RCM services provider, empowering healthcare professionals across India.
              </p>
              <div className="alpha_footer_pg_divider_line" />
              <div className="alpha_footer_pg_social_row">
                <a
                  href="https://youtube.com/@alphaingenmcbc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="alpha_footer_pg_social_btn alpha_footer_pg_yt"
                  aria-label="YouTube"
                >
                  <i className="fab fa-youtube"></i>
                  <span className="alpha_footer_pg_social_tooltip">YouTube</span>
                </a>
                <a
                  href="https://www.instagram.com/alphaingen_mcbc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="alpha_footer_pg_social_btn alpha_footer_pg_ig"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                  <span className="alpha_footer_pg_social_tooltip">Instagram</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/alphaingen-medical-coding-and-billing-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="alpha_footer_pg_social_btn alpha_footer_pg_li"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                  <span className="alpha_footer_pg_social_tooltip">LinkedIn</span>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="alpha_footer_pg_links_col">
              <h5 className="alpha_footer_pg_col_title">
                <span className="alpha_footer_pg_title_accent">Quick</span> Links
              </h5>
              <ul className="alpha_footer_pg_link_list">
                {[
                  { label: 'Services', section: 'programme' },
                  { label: 'Learning', section: 'programme' },
                  { label: 'Why Alphaingen', section: 'whychoose' },
                  { label: 'Enroll Now', section: 'endroll' },
                ].map(({ label, section }) => (
                  <li key={label} className="alpha_footer_pg_link_item">
                    <button
                      className="alpha_footer_pg_link_btn"
                      onClick={() => scrollToSection(section)}
                    >
                      <span className="alpha_footer_pg_link_arrow">&#8594;</span>
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="alpha_footer_pg_contact_col">
              <h5 className="alpha_footer_pg_col_title">
                <span className="alpha_footer_pg_title_accent">Get in</span> Touch
              </h5>
              <ul className="alpha_footer_pg_contact_list">
                <li className="alpha_footer_pg_contact_item">
                  <span className="alpha_footer_pg_contact_icon">
                    <i className="fas fa-envelope"></i>
                  </span>
                  <a href="mailto:info@alphaingen.com" className="alpha_footer_pg_contact_link">
                    info@alphaingen.com
                  </a>
                </li>
                <li className="alpha_footer_pg_contact_item">
                  <span className="alpha_footer_pg_contact_icon">
                    <i className="fas fa-phone-alt"></i>
                  </span>
                  <a href="tel:+919445352946" className="alpha_footer_pg_contact_link">
                    +91 94453 52946
                  </a>
                </li>
                <li className="alpha_footer_pg_contact_item alpha_footer_pg_address_item">
                  <span className="alpha_footer_pg_contact_icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </span>
                  <address className="alpha_footer_pg_address">
                    13C, Mosque Street,<br />
                    M.G. Nagar, Tharamani,<br />
                    Chennai, Tamil Nadu 600113
                  </address>
                </li>
              </ul>
            </div>

            {/* Map */}
            <div className="alpha_footer_pg_map_col">
              <h5 className="alpha_footer_pg_col_title">
                <span className="alpha_footer_pg_title_accent">Find</span> Us
              </h5>
              <div className="alpha_footer_pg_map_frame">
                <div className="alpha_footer_pg_map_inner">
                  <iframe
                    title="Alphaingen Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.123456789!2d80.2406374!3d12.981489!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267b8f1a1e1e1%3A0x48188024511c3b88!2sAlphaingen%20Medical%20Coding%20and%20Billing%20Center!5e0!3m2!1sen!2sin!4v1610000000000!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div className="alpha_footer_pg_map_badge">
                  <i className="fas fa-map-pin"></i> Tharamani, Chennai
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Bottom divider wave */}
        <div className="alpha_footer_pg_bottom_wave">
          <svg viewBox="0 0 1440 30" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,15 C480,30 960,0 1440,15 L1440,30 L0,30 Z" fill="rgba(70,0,0,0.12)" />
          </svg>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="alpha_footer_pg_copyright">
        <div className="alpha_footer_pg_copyright_inner">
          <span>
            &copy; {new Date().getFullYear()} <strong>Alphaingen</strong>. All Rights Reserved.
          </span>
          <span className="alpha_footer_pg_copyright_tagline">
            Empowering Healthcare Careers
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;